import ipc from '@/renderer/scripts/utils/ipc';
import { getUrlQuery } from '@/renderer/scripts/utils/tools';

// pc端sso登录使用插入webview来触发登录
export default function dispatchWebview({ url, className }: { url: string; className?: string }) {
  // 插入元素
  const content = document.createElement('div');
  content.className = `login-webview-content no-drag-bar${className ? ` ${className}` : ''}`;
  const closeBtn = document.createElement('div');
  closeBtn.className = 'login-webview-close close-icon';
  content.appendChild(closeBtn);
  const webview = document.createElement('webview');
  webview.id = 'ssoLoginWebview';
  webview.src = url;
  webview.useragent = 'TCED_WEBVIEW';
  // 指定partition 清理缓存时用到
  webview.partition = 'persist:ssoLoginPartition';

  const loading = document.createElement('div');
  loading.className = `login-webview-content-loading`;
  content.append(loading);
  document.body.appendChild(content);

  // 使用 fetch 预加载一次 url，使得 webview 加载时利用缓存 打开更快。
  // 手动加入 loading 增强用户体验
  fetch(url).then(() => {
    content.appendChild(webview);
    content.removeChild(loading);
  });

  const removeWebview = () => {
    webview.removeEventListener('did-navigate', ssoLogin);
    closeBtn.removeEventListener('click', removeWebview);
    document.body.removeChild(content);
  };

  closeBtn.addEventListener('click', removeWebview);

  const ssoLogin = (e: { url: string }) => {
    const { url } = e;
    const queryResult = getUrlQuery(url);
    const { query } = queryResult;
    const { ticket, code, state } = query;
    // cas协议登录
    if (ticket) {
      ipc.emit(ipc.RENDERER_EVENTS_MAP.SSO_WEBVIEW_LOGIN, { ticket });
      removeWebview();
      return;
    }
    // 其他sso协议登录
    if (code && state && state.includes('_') && (state as string).startsWith('oauth_')) {
      ipc.emit(ipc.RENDERER_EVENTS_MAP.SSO_WEBVIEW_LOGIN, { code, state });
      removeWebview();
    }
  };

  // 回调到网盘登录页时触发
  webview.addEventListener('did-navigate', ssoLogin);
}
